import React from 'react'
import styled, { css } from 'styled-components'
import Link from 'next/link'
import { useUserAgentStore } from 'store/userAgentStore'

import { tabletSize } from 'theme'
import { active, hidden } from './mixin'
import { openLinkBlank } from 'utils/appSchemeUtil'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import ImageHome from '/static/images/ic-home.svg'
import ImageHomeActive from '/static/images/ic-home-active.svg'
import ImageMyCoupon from '/static/images/ic-my-coupon.svg'
import ImageMyCouponActive from '/static/images/ic-my-coupon-active.svg'
import EarnPointSvg from '/static/images/tabs/ic-earn-point.svg'
// import TncSvg from '/static/images/tabs/ic-tnc.svg'
import UserGuideSvg from '/static/images/tabs/ic-user-guide.svg'

const tabs = [
  {
    title: '主頁',
    titleInMobile: '主頁',
    pathname: '/skus',
    iconComponent: <ImageHome />,
    iconActiveComponent: <ImageHomeActive />,
  },
  {
    title: '我的優惠券',
    titleInMobile: '我的',
    pathname: '/mycoupon',
    iconComponent: <ImageMyCoupon />,
    iconActiveComponent: <ImageMyCouponActive />,
  },
]

// TODO: DO ALL THE TRACKING FOR ALL THE TABS
const Tabs = ({ currentPathname }) => (
  <TabsWrapper>
    {tabs.map((tab) => (
      <Link href={tab.pathname} key={tab.pathname} replace>
        <Tab active={currentPathname === tab.pathname}>{tab.title}</Tab>
      </Link>
    ))}
    <MoreTab />
  </TabsWrapper>
)

const MoreTab = () => {
  const userAgentStore = useUserAgentStore()
  const isPWA = userAgentStore.isPWA
  const subTabsList = [
    {
      icon: <EarnPointSvg />,
      title: '如何賺取積分',
      link: encodeURI(
        'https://www.hk01.com/獎賞專區/371302/香港01會員獎賞計劃'
      ),
    },
    // TODO: uncomment the following lines when the hk01 terms include t&c for 01coupon
    // {
    //   icon: <TncSvg />,
    //   title: '條款與細則',
    //   link: encodeURI('https://www.hk01.com/terms'),
    // },
    {
      icon: <UserGuideSvg />,
      title: '添加01優惠券到主畫面',
      link: '/userguide',
      hideInPWA: true,
    },
  ]
  const onSubTabClick = (item) => {
    openLinkBlank(item.link)
  }
  const arrowStyle = { color: '#525252', fontSize: 16 }
  return (
    <MoreTabBox>
      <TabText>
        更多
        <ExpandMoreIcon style={arrowStyle} />
      </TabText>
      <MoreSubTabPanel>
        <MoreSubTabWapper>
          {subTabsList.map(
            (item, index) =>
              !(item.hideInPWA && isPWA()) && (
                <MoreSubTab key={index} onClick={() => onSubTabClick(item)}>
                  {item.icon}
                  {item.title}
                </MoreSubTab>
              )
          )}
        </MoreSubTabWapper>
      </MoreSubTabPanel>
    </MoreTabBox>
  )
}

const SideBarTabs = ({ currentPathname, onTabClick }) => (
  <SideBarTabsWrapper>
    {tabs.map((tab) => (
      <Link href={tab.pathname} key={tab.pathname} replace>
        <TabIsInMenu
          active={currentPathname === tab.pathname}
          onClick={onTabClick}
        >
          {tab.title}
          {currentPathname === tab.pathname
            ? tab.iconActiveComponent
            : tab.iconComponent}
        </TabIsInMenu>
      </Link>
    ))}
  </SideBarTabsWrapper>
)

const TabsWrapper = styled.div`
  display: flex;
  @media ${tabletSize} {
    ${hidden};
  }
`

const Tab = styled.span`
  line-height: 64px;
  font-size: 16px;
  padding: 0 9px;
  margin: 0 15px;
  cursor: pointer;
  color: ${(p) => p.theme.color.grey600};
  position: relative;
  user-select: none;
  ${(p) =>
    p.active &&
    css`
      ${active};
      &:after {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        background: ${(p) => p.theme.color.blue300};
        height: 4px;
        width: 100%;
        border-radius: 2px;
      }
    `}
`

const SideBarTabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
`

const TabIsInMenu = styled.div`
  display: flex;
  height: 56px;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
  ${(p) =>
    p.active &&
    css`
      ${active};
      border-radius: 4px;
      background-color: ${(p) => p.theme.color.grey50};
    `}
`

const MoreSubTabPanel = styled.div`
  background: ${(p) => p.theme.color.white};
  position: absolute;
  left: 0;
  width: 100%;
  display: none;
`
const MoreTabBox = styled.div`
  line-height: 64px;
  font-size: 16px;
  padding: 0 9px;
  margin: 0 15px;
  cursor: pointer;
  color: ${(p) => p.theme.color.grey600};
  user-select: none;
  &:hover {
    font-weight: 600;
    ${MoreSubTabPanel} {
      display: block;
    }
  }
`

const TabText = styled.div`
  display: flex;
  align-items: center;
`

const MoreSubTabWapper = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`

const MoreSubTab = styled.div`
  svg {
    padding: 0 45px;
    padding-bottom: 8px;
    display: block;
    transition: all 0.5s linear;
    &:hover {
      transform: scale(1.1);
    }
  }
  text-align: center;
  color: ${(p) => p.theme.color.dark200};
  font-size: 16px;
  line-height: 1.5;
`

export { Tabs as default, SideBarTabs }
